import { render, staticRenderFns } from "./PlaceElement.vue?vue&type=template&id=2e4c745c&"
import script from "./PlaceElement.vue?vue&type=script&lang=js&"
export * from "./PlaceElement.vue?vue&type=script&lang=js&"
import style0 from "./PlaceElement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports